import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { Box, Button, Typography, TextField, Grid } from '@material-ui/core'

import { isEmpty } from 'lodash'
import telephone from '@scoir/components-core/dist/components/telephone'

const REQUIRED_FIELDS = ['FirstName', 'LastName']

const mdashIfEmpty = (val) => {
  return val || <Fragment>&mdash;</Fragment>
}

const validatePhoneNum = (fmtNum) => {
  if (isEmpty(fmtNum)) return true
  return fmtNum.length >= 10 && fmtNum.length <= 13
}

export class ProfileInfo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isExtValid: true,
      isPhoneValid: true,
      isCellValid: true,
      isEditing: false,
    }
  }
  componentDidMount() {
    document.title = 'Scoir - My Profile Info'
  }
  updateUser(field, value) {
    this.setState({
      editUser: {
        ...this.state.editUser,
        [field]: value,
      },
    })
  }
  toggleEditing() {
    const isEditing = !this.state.isEditing
    if (isEditing) {
      this.setState({
        editUser: { ...this.props.user },
      })
    }
    this.setState({
      isEditing: isEditing,
    })
  }
  canSave() {
    return (
      REQUIRED_FIELDS.reduce((result, field) => {
        return result && !isEmpty(this.state.editUser[field])
      }, true) &&
      this.state.isPhoneValid &&
      this.state.isCellValid &&
      this.state.isExtValid
    )
  }
  saveUpdates() {
    this.props.onSave(this.state.editUser).then(() => {
      this.toggleEditing()
    })
  }
  updateProfile() {
    return (
      <>
        <Grid
          container
          spacing={1}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <TextField
              label="First Name"
              value={this.state.editUser.FirstName}
              required
              onChange={(e) => this.updateUser('FirstName', e.target.value)}
              variant="outlined"
              margin="normal"
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <TextField
              label="Middle Name"
              value={this.state.editUser.MiddleName}
              onChange={(e) => this.updateUser('MiddleName', e.target.value)}
              variant="outlined"
              margin="normal"
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <TextField
              label="Last Name"
              value={this.state.editUser.LastName}
              required
              onChange={(e) => this.updateUser('LastName', e.target.value)}
              variant="outlined"
              margin="normal"
              fullWidth
            />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={1}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <TextField
              label="Title"
              value={this.state.editUser.Title}
              onChange={(e) => this.updateUser('Title', e.target.value)}
              variant="outlined"
              margin="normal"
              fullWidth
            />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={1}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <TextField
              label="Work Phone"
              value={telephone.format(this.state.editUser.Phone)}
              onChange={(e) => {
                const num = e.target.value
                const fmtNum = telephone.unformat(num)
                const isPhoneValid = validatePhoneNum(fmtNum)
                this.setState({ isPhoneValid })
                this.updateUser('Phone', fmtNum)
              }}
              variant="outlined"
              margin="normal"
              fullWidth
              helperText="(###)-###-####"
              error={!this.state.isPhoneValid}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <TextField
              label="Ext."
              inputProps={{ maxLength: 5 }}
              value={this.state.editUser.PhoneExtension}
              onChange={(e) => {
                const PhoneExtension = e.target.value
                const isExtValid = PhoneExtension.length === 0 || /^\d+$/.test(PhoneExtension)
                this.setState({ isExtValid })
                this.updateUser('PhoneExtension', PhoneExtension)
              }}
              variant="outlined"
              margin="normal"
              fullWidth
              error={!this.state.isExtValid}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <TextField
              label="Cell Phone"
              value={telephone.format(this.state.editUser.CellPhone)}
              onChange={(e) => {
                const num = e.target.value
                const fmtNum = telephone.unformat(num)
                const isCellValid = validatePhoneNum(fmtNum)
                this.setState({ isCellValid })
                this.updateUser('CellPhone', fmtNum)
              }}
              variant="outlined"
              margin="normal"
              fullWidth
              helperText="(###)-###-####"
              error={!this.state.isCellValid}
            />
          </Grid>
        </Grid>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          mt={2}
        >
          <Box mr={1}>
            <Button
              color="primary"
              onClick={() => this.toggleEditing()}
            >
              Cancel
            </Button>
          </Box>
          <Button
            className="save"
            color="primary"
            variant="contained"
            disabled={!this.canSave()}
            onClick={() => this.saveUpdates()}
          >
            Save
          </Button>
        </Box>
      </>
    )
  }
  readOnlyProfile() {
    return (
      <Box>
        <Box>
          <Box
            mb={1}
            display="flex"
            alignItems="center"
          >
            <Typography variant="h6">
              {this.props.user.FirstName} {this.props.user.LastName}
            </Typography>
            <Button
              color="primary"
              onClick={() => this.toggleEditing()}
            >
              Edit
            </Button>
          </Box>
          <Box
            mb={1}
            display="flex"
            alignItems="center"
          >
            <Typography>
              <strong>Title</strong>
            </Typography>
            <Box ml={1}>
              <Typography>{mdashIfEmpty(this.props.user.Title)}</Typography>
            </Box>
          </Box>
        </Box>
        <Box
          mb={1}
          display="flex"
          alignItems="center"
        >
          <Box
            display="flex"
            alignItems="center"
          >
            <Typography>
              <strong>Work</strong>
            </Typography>
            <Box ml={1}>
              <Typography>{mdashIfEmpty(telephone.format(this.props.user.Phone))}</Typography>
            </Box>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            ml={2}
          >
            <Typography>
              <strong>Ext.</strong>
            </Typography>
            <Box ml={1}>
              <Typography>{mdashIfEmpty(this.props.user.PhoneExtension)}</Typography>
            </Box>
          </Box>
        </Box>
        <Box
          display="flex"
          alignItems="center"
        >
          <Typography>
            <strong>Cell</strong>
          </Typography>
          <Box ml={1}>
            <Typography>{mdashIfEmpty(telephone.format(this.props.user.CellPhone))}</Typography>
          </Box>
        </Box>
      </Box>
    )
  }
  render() {
    return (
      <Box
        width="100%"
        height="100%"
        bgcolor="background.paper"
        padding={2}
      >
        {this.state.isEditing ? this.updateProfile() : this.readOnlyProfile()}
      </Box>
    )
  }
}

ProfileInfo.propTypes = {
  user: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
}

export default ProfileInfo
